// (function () {
// 	'use strict';

//     const module = angular.module('imApp');

//     module.component('incomingCall', {
//         templateUrl: 'views/components/views/incomingCall/incomingCall.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'utilityService', 'incomingCallService', function ($stateParams, utilityService, incomingCallService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let phoneNo = $stateParams.phoneno;
            
//     		vm.model = {
//     			info: {},
//     			itemsListFindPersons: []
//     		};

//             // #endregion VARIABLES & DEFINITIONS

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadInfo() {
//                 vm.model.info = (await incomingCallService.getInfo({ phoneno: phoneNo }))[0];
//             }
            
//             async function loadFindPersons() {
//                 if (utilityService.validateParmsValue(vm.model.info.phoneno) !== true) return;
                
//                 return vm.model.itemsListFindPersons = await incomingCallService.listFindPersons({ searchtext: vm.model.info.phoneno });
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 await loadInfo();
//                 loadFindPersons();
//             }

//             // #endregion ON INIT FUNCTION

//     	}]
//     });
// })();
